import { useState, useContext } from "react";
import SwipeableViews from "react-swipeable-views";
import { Typography } from "@mui/material";
import { green, red } from "@mui/material/colors";
import Fade from "react-reveal/Fade";

// Custom components
import { SelectAnswerContext } from "../contexts/selectAnswerContext";
import { LangContext } from "../contexts/langContext";
import useShowingCorrectAnswer from "../hooks/useShowingCorrectAnswer";

const YesNoWrapper = ({
  children,
  contentFadeDelay,
  questionRenderProps,
  showCorrect,
  readonly,
}) => {
  const { translatePageText } = useContext(LangContext);
  const [percentSwitched, setPercentSwitched] = useState(1);
  const { onSelectAnswer } = useContext(SelectAnswerContext);
  const isShowingCorrectAnswer = useShowingCorrectAnswer();
  const displayCorrectAnswer = isShowingCorrectAnswer || showCorrect;

  const yesScore = questionRenderProps.yesScore;
  const noScore = questionRenderProps.noScore;

  const handleAnswer = (yesOrNo) => {
    if (yesOrNo === "yes") {
      onSelectAnswer(yesScore, {
        val1: 0,
        val2: yesScore === "correct" ? 1 : 0,
        val3: yesScore === "incorrect" ? 1 : 0,
      });
    } else if (yesOrNo === "no") {
      onSelectAnswer(noScore, {
        val1: 0,
        val2: noScore === "correct" ? 1 : 0,
        val3: noScore === "incorrect" ? 1 : 0,
      });
    }
  };

  const handleUpdateIndex = (newIndex, lastestIndex) => {
    if (newIndex === 0) {
      handleAnswer("yes");
    } else if (newIndex === 2) {
      handleAnswer("no");
    }
  };

  const handleAction = (percent) => {
    setPercentSwitched(percent);
  };

  return (
    <SwipeableViews
      onSwitching={handleAction}
      index={1}
      enableMouseEvents
      id="yesNoWrapper"
      onChangeIndex={handleUpdateIndex}
      slideStyle={{
        height: "calc(90vh - 60px)",
        overflow: "hidden",
      }}
    >
      <div />

      <div>
        <div style={{ pointerEvents: "none" }}>{children}</div>
        <Fade delay={contentFadeDelay}>
          <Typography
            style={{
              textAlign: "center",
              pointerEvents: "none",
              opacity: 0.6,
            }}
            variant="body2"
          >
            {translatePageText("general.swipeOrClick")}
          </Typography>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              pointerEvents: "none",
            }}
          >
            <div
              style={{
                textAlign: "center",
                marginRight: "10%",
                pointerEvents: "auto",
                transform: "scale(" + Math.pow(Number(1 + (1 - percentSwitched)), 4) + ")",
                color: !displayCorrectAnswer
                  ? undefined
                  : yesScore === "correct"
                  ? green[500]
                  : red[500],
              }}
            >
              <Typography
                onClick={() => {
                  if (readonly === false) {
                    handleAnswer("yes");
                  }
                }}
                style={{
                  cursor: readonly === false ? "pointer" : undefined,
                  margin: 0,
                  padding: "3px 0px",
                }}
                variant="h3"
                component="span"
                letterSpacing="-0.05em"
              >
                {translatePageText("general.yes")}
              </Typography>
              <p style={{ margin: 0 }}>
                {displayCorrectAnswer &&
                  yesScore === "correct" &&
                  translatePageText("progressionDisplay.correct")}
                {displayCorrectAnswer &&
                  yesScore === "incorrect" &&
                  translatePageText("progressionDisplay.wrong")}
              </p>
            </div>
            <div
              style={{
                textAlign: "center",
                marginLeft: "10%",
                pointerEvents: "auto",
                transform: "scale(" + Math.pow(percentSwitched, 4) + ")",
                color: !displayCorrectAnswer
                  ? undefined
                  : noScore === "correct"
                  ? green[500]
                  : red[500],
              }}
            >
              <Typography
                onClick={() => {
                  if (readonly === false) {
                    handleAnswer("no");
                  }
                }}
                style={{
                  cursor: readonly === false ? "pointer" : undefined,
                  margin: 0,
                  padding: "3px 0px",
                }}
                variant="h3"
                component="span"
                letterSpacing="-0.05em"
              >
                {translatePageText("general.no")}
              </Typography>
              <p style={{ margin: 0 }}>
                {displayCorrectAnswer &&
                  noScore === "correct" &&
                  translatePageText("progressionDisplay.correct")}
                {displayCorrectAnswer &&
                  noScore === "incorrect" &&
                  translatePageText("progressionDisplay.wrong")}
              </p>
            </div>
          </div>
        </Fade>
      </div>

      <div />
    </SwipeableViews>
  );
};

export default YesNoWrapper;
